import axios from 'axios'
import store from '../store'
import router from '../router'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_API_URL
})

axiosInstance.interceptors.request.use(
  function (config) {
    if (config.headers.auth === false) {
      return config
    }

    const token = store.getters['auth/accessToken']
    if (token) {
      config.headers.Authorization = token
    }
    return config
  },
  error => Promise.reject(error)
)

axiosInstance.interceptors.response.use(
  response => response,
  async function (error) {
    const originalRequest = error.config

    if (
      error.response.status === 401 &&
      originalRequest.url.includes('/auth/v1/refresh')
    ) {
      store.commit('auth/clearUserData')
      router.push('/login')
      return Promise.reject(error)
    } else if (
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true
      await store.dispatch('auth/refreshToken')

      const newAccessToken = store.getters['auth/accessToken']
      originalRequest.headers.Authorization = newAccessToken
      return axios(originalRequest)
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
